import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SavedSearchTable, LoadingSpinner } from 'yankees-react-utils';
import PropTypes from 'prop-types';
import { useOktaQuery, VideoSearch as vSearch } from '../../data';
import SavedSearchModal from './SavedSearchModal';
import DeleteSavedSearchModal from './DeleteSavedSearchModal';

const SavedSearches = ({ onVideoClick, filter }) => {
    const { t: translate } = useTranslation();
    const { data: savedSearches, isFetching } = useOktaQuery('video-searches', vSearch.get);
    const [editingSearch, setEditingSearch] = useState({});
    const [showSaveSearchModal, setShowSaveSearchModal] = useState(false);
    const [deletingSearch, setDeletingSearch] = useState({});
    const [showDeleteSearchModal, setShowDeleteSearchModal] = useState(false);

    const modalContainer = useRef();

    const onEdit = (savedSearch) => {
        setShowSaveSearchModal(true);
        setEditingSearch(savedSearch);
    };

    const onDelete = (savedSearch) => {
        setShowDeleteSearchModal(true);
        setDeletingSearch(savedSearch);
    };

    const onUpdate = (updatedSearch) => {
        const savedSearchIndex = savedSearches.findIndex((ss) => ss.VideoSearchID === updatedSearch.VideoSearchID);
        savedSearches.splice(savedSearchIndex, 1, updatedSearch);
    };

    const onSearchDeleted = (updatedSearch) => {
        const savedSearchIndex = savedSearches.findIndex((ss) => ss.VideoSearchID === updatedSearch.VideoSearchID);
        savedSearches.splice(savedSearchIndex, 1);
    };

    if (isFetching) {
        return (
            <div className="d-flex justify-content-center py-5">
                <LoadingSpinner />
            </div>
        );
    }

    return (
        <div className="p-2" ref={modalContainer}>
            <h3 className="mb-3">{translate('sections.video-playlists.saved-searches')}</h3>
            {savedSearches.length
                ? <SavedSearchTable rows={savedSearches || []} onEdit={onEdit} onDelete={onDelete} onVideoClick={onVideoClick} />
                : <div className="d-flex justify-content-center py-5 text-muted">{translate('sections.video-playlists.no-saved-searches')}</div>}

            <SavedSearchModal
                showModal={showSaveSearchModal}
                setShowModal={setShowSaveSearchModal}
                modalContainer={modalContainer}
                savedSearch={editingSearch}
                onUpdate={onUpdate}
                filter={filter}
            />
            <DeleteSavedSearchModal
                showModal={showDeleteSearchModal}
                setShowModal={setShowDeleteSearchModal}
                modalContainer={modalContainer}
                savedSearch={deletingSearch}
                onDelete={onSearchDeleted}
            />
        </div>
    );
};

SavedSearches.propTypes = {
    onVideoClick: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    filter: PropTypes.object,
};

SavedSearches.defaultProps = {
    filter: {},
};

export default SavedSearches;
